const VALIDATOR_TYPE_REQUIRE = "REQUIRE";
const VALIDATOR_TYPE_SELECT = "SELECT";
const VALIDATOR_TYPE_SELECT_VALIDATED = "SELECT_VALIDATED";
const VALIDATOR_TYPE_MINLENGTH = "MINLENGTH";
const VALIDATOR_TYPE_MAXLENGTH = "MAXLENGTH";
const VALIDATOR_TYPE_MAX = "MAX";
const VALIDATOR_TYPE_MIN = "MIN";
const VALIDATOR_TYPE_FILE = "FILE";
const VALIDATOR_TYPE_EMAIL = "EMAIL";
const VALIDATOR_TYPE_PASSWORD = "PASSWORD";
const VALIDATOR_TYPE_AUTOCOMPLETE = "AUTOCOMPLETE";
const VALIDATOR_TYPE_VALIDATED = "VALIDATED";
const VALIDATOR_TYPE_DATE = "DATE";
const VALIDATOR_TYPE_NUMBER_ONLY = "NUMBER_ONLY";

export const VALIDATOR_REQUIRE = (val) => ({
	type: VALIDATOR_TYPE_REQUIRE,
	val: val,
});
export const VALIDATOR_SELECT = (val) => ({
	type: VALIDATOR_TYPE_SELECT,
	val: val,
});
export const VALIDATOR_SELECT_VALIDATED = (val) => ({
	type: VALIDATOR_TYPE_SELECT,
	val: val,
});
export const VALIDATOR_MINLENGTH = (val) => ({
	type: VALIDATOR_TYPE_MINLENGTH,
	val: val,
});
export const VALIDATOR_MAXLENGTH = (val) => ({
	type: VALIDATOR_TYPE_MAXLENGTH,
	val: val,
});
export const VALIDATOR_MAX = (val) => ({ type: VALIDATOR_TYPE_MAX, val: val });
export const VALIDATOR_DATE = (val) => ({
	type: VALIDATOR_TYPE_DATE,
	val: val,
});
export const VALIDATOR_MIN = (val) => ({ type: VALIDATOR_TYPE_MIN, val: val }); //for example val:3
export const VALIDATOR_EMIAL = () => ({ type: VALIDATOR_TYPE_EMAIL });
export const VALIDATOR_FILE = () => ({ type: VALIDATOR_TYPE_FILE });
export const VALIDATOR_PASSWORD = (val) => ({
	type: VALIDATOR_TYPE_PASSWORD,
	val: val,
});
export const VALIDATOR_AUTOCOMPLETE = () => ({
	type: VALIDATOR_TYPE_AUTOCOMPLETE,
}); //for example val = an array of doctors
export const VALIDATOR_VALIDATED = () => ({ type: VALIDATOR_TYPE_VALIDATED });

export const VALIDATOR_NUMBER_ONLY = (val) => ({
	type: VALIDATOR_TYPE_NUMBER_ONLY,
	val: val,
});

export const validate = (value, validators) => {
	let isValid = true;
	for (const validator of validators) {
		if (validator.type === VALIDATOR_TYPE_REQUIRE) {
			isValid = isValid && value.trim().length > 0;
		}
		if (validator.type === VALIDATOR_TYPE_SELECT) {
			isValid = isValid && value.length > 0;
		}
		if (validator.type === VALIDATOR_TYPE_SELECT_VALIDATED) {
			isValid = true;
		}
		if (validator.type === VALIDATOR_TYPE_DATE) {
			isValid = isValid && (value === null ? false : value._isValid);
		}
		if (validator.type === VALIDATOR_TYPE_VALIDATED) {
			isValid = true;
		}
		if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
			isValid = isValid && value.trim().length >= validator.val;
		}
		if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
			isValid = isValid && value.trim().length <= validator.val;
		}
		if (validator.type === VALIDATOR_TYPE_MIN) {
			isValid = isValid && +value >= validator.val;
		}
		if (validator.type === VALIDATOR_TYPE_MAX) {
			isValid = isValid && +value <= validator.val;
		}
		if (validator.type === VALIDATOR_TYPE_EMAIL) {
			isValid = isValid && /^\S+@\S+\.\S+$/.test(value);
		}
		if (validator.type === VALIDATOR_TYPE_AUTOCOMPLETE) {
			isValid = isValid && value !== null;
		}
		if (validator.type === VALIDATOR_TYPE_NUMBER_ONLY) {
			const regex = /^\d*(\.\d+)?$/;
			isValid = isValid && regex.test(value);
		}
	}
	return isValid;
};
